//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
let d=[[[0,"BuildStatus",0,0],[0,"DesignStatus",1,0],[0,"DisplayStatus",1,0],[0,"Radius",1,0],[0,"Step",1,0],[0,"Type",1,0]],[[["title","value","color"],"GetExtensionAttributes",{},0,0],[["title","value","color"],"SetExtensionAttributes",{},3,0],[["title","value","color"],"GetCavityAttributes",{},0,0],[["title","value","color"],"SetCavityAttributes",{},3,0],[[],"CreateChild",{R_:{diethroatchild:"Die.ThroatChildBuilder"}},0,0],[["diethroatchild"],"DeleteChild",{},1,0],[["num_children"],"GetChildren",{R_:{children:"Die.ThroatChildBuilder[]"}},0,0]],[]];
SPLM.Die.ThroatParentBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.ThroatParentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.ThroatParentBuilder.TypeOption = Object.freeze({
    "Wipe" : "Wipe", "Restrike" : "Restrike"});

export default SPLM;